/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanySummaryResponse } from '../../models/company-summary-response';

export interface GetCompanySummary$Params {
}

export function getCompanySummary(http: HttpClient, rootUrl: string, params?: GetCompanySummary$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanySummaryResponse>> {
  const rb = new RequestBuilder(rootUrl, getCompanySummary.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanySummaryResponse>;
    })
  );
}

getCompanySummary.PATH = '/api/company/summary';
